import {ConversationMessage} from '@/types/conversationMessage';
import api from '@/api';

const CONTENT_SUBMISSION_VERSIONS_PATH = 'content_submission_versions';

type SendVersionMessageParams = {
  versionId: string;
  body: string;
  sentFromBrandId?: string;
};

const contentSubmissionVersionMessagesUpdaters = {
  sendMessage: async (
    params: SendVersionMessageParams
  ): Promise<ConversationMessage> => {
    const {versionId, body, sentFromBrandId} = params;
    const result = await api.post(
      `${CONTENT_SUBMISSION_VERSIONS_PATH}/${versionId}/messages`,
      {
        body,
        ...(sentFromBrandId ? {sentFromBrandId} : {}),
      }
    );
    return result.data as ConversationMessage;
  },
};

export default contentSubmissionVersionMessagesUpdaters;
